import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import type { CollectorSelfProfileOptions } from './collectorSelfProfileOptions';
import { client } from '../client';
import { UserRoleName } from './types/UserProfile';

export const confirmAvatarMedia = async (
  media_id: string,
  user_id: number,
  dependent_id?: number,
  userRole?: string,
  options?: CollectorSelfProfileOptions,
): Promise<Response> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const useCollectorMe = userRole === UserRoleName.Collector && options?.collectorEditingSelf === true;
  const url = useCollectorMe ? '/collector/me/confirm_avatar' : `${prefix}/users/${user_id}/confirm_avatar`;
  const { data } = await client.patch<Response>(url, { media_id, dependent_id });

  return data;
};
